import { MAIN_QUESTS_GROUP, appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const somnisQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-wishlist-added",
    ruleId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/somnis-rumble-rush/somnis-onboarding-quest.mp4`,
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-trailer-event",
    ruleId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-trailer",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationMobile",
    label: "Download the game",
    caption: "",
    linkUrl: "https://overtake.world/games/obt/somnis",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-download-completed",
    ruleId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-download",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Somnis: Rumble Rush on X",
    caption: "Don't miss a tweet",
    increase: 10,
    badgeIcon: "ImxRewards",
    linkUrl: "https://x.com/somnis_world",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-twitter-event",
    ruleId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-twitter",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-onboarding-bonus-event",
    ruleId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-onboarding-bonus",
  },
  // TODO: add back when twitch drop is ready
  // {
  //   type: "custom",
  //   key: "bonus-variant-2",
  //   icon: "TreasureChest",
  //   label: "Discover if you won",
  //   caption: "Winners announced",
  //   increase: 0,
  //   badgeIcon: "TreasureChest",
  //   badgeTemplate: "Win an exclusive NFT <icon>",
  //   eventId: "this-will-never-be-completed",
  //   ruleId: "this-will-never-be-completed",
  // },
];

const somnisQuestsRecurring: Quest[] = [
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about playing Somnis",
    caption: "Extra Gems daily for sharing on X",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-recurring-tweet-completed",
    ruleId: "75521950-3d5f-4bdd-883f-ba792c0f4c06-recurring-tweet",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: "@somnis_world",
    recurring: true,
    tweetUsername: "@somnis_world",
  },
];

export const somnisQuests: QuestGroup[] = [
  {
    key: "level-0",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +55 <icon> Gems",
    nextQuest: {
      url: "/",
      title: "Thanks for getting involved",
      label: "Discover new games you can support",
      caption: "Do quests & earn rewards",
    },
    totalGemsGranted: 55,
    quests: somnisQuestsList,
    hideOnCompletion: false,
  },
  {
    key: "recurring",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn extra gems daily",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Earn Gems daily by posting to socials",
    },
    totalGemsGranted: 10,
    quests: somnisQuestsRecurring,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
